import AdminPanelShortcut from "./admin-panel-shortcut";
import BackButton from "./back-button";
import NavButtonNextAndPrev from "./nav-button-next-and-prev";
import { Navigate, useParams } from "react-router-dom";

export default function ReturnNav() {
  const { returnId, shopId } = useParams<{
    returnId: string;
    shopId: string;
  }>();

  if (!shopId) {
    return <Navigate to={"/shops"} />;
  }

  if (!returnId) {
    return <Navigate to={`/shops/${shopId}/returns`} replace />;
  }

  return (
    <div className={"flex items-center justify-between h-12 xl:-mt-12"}>
      <div className={"flex items-center flex-row gap-2"}>
        <BackButton />
      </div>
      <div className={"flex flex-row items-center gap-3"}>
        <AdminPanelShortcut returnId={returnId} />
        <NavButtonNextAndPrev returnId={returnId} />
      </div>
    </div>
  );
}
